import browserStack from './config.estacio.browser-stack';
import dev from './config.estacio.dev';
import hml from './config.estacio.hml';
import local from './config.estacio.local';
import prod from './config.estacio.prod';

export default { local, dev, prod, browserStack, hml };
